import { type IAdvertise } from '../../../store/slices/advertisesSlice'
import { normalizeLinkStatus, splitAdvertiseLinks } from './portalLinks'

export interface StateLink {
    Title?: string
    Link?: string
    Status: string
    Trakheesi_id: string
    Comment?: string
    Disabled?: boolean
    __sourceIndex?: number
}

export const reduceLinks = (currentAdvertise: IAdvertise) => {
    const { portals } = splitAdvertiseLinks(currentAdvertise?.attributes?.Links)
    const mappedLinks: StateLink[] = portals.map((el) => {
        const returnObject: StateLink = {
            Title: '',
            Link: '',
            Trakheesi_id: '',
            Status: 'In-process',
            Comment: '',
            Disabled: false,
            __sourceIndex: el.__sourceIndex
        }
        if (el !== null) {
            returnObject.Status = normalizeLinkStatus(el?.Status)
            if (el.hasOwnProperty('Title') && el.Title !== '' && el.Title != null) {
                returnObject.Title = el.Title
            }
            if (el.hasOwnProperty('Link') && el.Link !== '' && el.Link != null) {
                returnObject.Link = el.Link
            }
            if (el.hasOwnProperty('Trakheesi_id') && el.Trakheesi_id !== '' && el.Trakheesi_id != null) {
                returnObject.Trakheesi_id = el.Trakheesi_id
            }
            if (el.hasOwnProperty('Comment') && el.Comment != null) {
                returnObject.Comment = String(el.Comment)
            }
            if (el.hasOwnProperty('Disabled')) {
                returnObject.Disabled = Boolean(el.Disabled)
            }
        }

        return returnObject
    })

    return mappedLinks
}
